<template>
  <v-container fluid>
    <v-layout wrap>
      <v-flex
        xs12
        sm12
        md3
        xl3>
        <formAdminMonthlyCrossChargeFilter :view="'customers'"/>
      </v-flex>
      <v-flex
        md9
        xl9/>
      <v-flex
        xs12
        sm12
        md12>
        <material-card
          color="orange"
          title="Customers"
          text="Number of accounts per customer"
        >
          <v-layout
            wrap>
            <v-flex
              xs12
              sm3
              md3>
              <v-text-field
                v-model="search"
                label="Search"
                single-line
                hide-details
                append-icon="search"
              />
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="customerHeaders"
            :items="totalNoOfAccountsByCustomer"
            :search ="search"
            :pagination.sync="pagination"
          >
            <template
              slot="headerCell"
              slot-scope="{ header }">
              <span
                class="subheading font-weight-light text-success text-md-left text--darken-3"
                v-text="header.text"
              />
            </template>
            <template
              v-slot:items="props">
              <td>
                <router-link
                  :to="'/admin/financial-administration/monthly-cross-charge/customers/'+ props.item.Client_Name">
                  {{ props.item.Client_Name }}
                </router-link>
              </td>
              <td>{{ props.item.No_of_Accts }}</td>
            </template>
          </v-data-table>
        </material-card>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data: () => ({
    loader: null,
    search: '',
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      totalItems: 0,
      sortBy: 'Client_Name'
    }
  }),
  computed: {
    ...mapState('admin/financialAdministration', ['customers', 'customerHeaders', 'allAccounts']),
    totalNoOfAccountsByCustomer () {
      let noOfAccountsByCustomer = this.allAccounts.reduce(function (accountsByCustomer, account) {
        if (!accountsByCustomer.hasOwnProperty(account.Client_Name)) {
          accountsByCustomer[account.Client_Name] = {
            Client_Name: account.Client_Name,
            // Customer_Id: account.Customer_Id,
            No_of_Accts: 0
          }
        }
        accountsByCustomer[account.Client_Name].No_of_Accts++
        return accountsByCustomer
      }, {})

      // lets convert it to array
      let totalAccountsByCustomer = []
      for (let [name, value] of Object.entries(noOfAccountsByCustomer)) {
        totalAccountsByCustomer.push(value)
      }
      return totalAccountsByCustomer
    }
  }
}
</script>
